<template>
    <div>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4 pr-6 pl-6>
            <v-layout row wrap justify-end>
              <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                      <v-text-field
                      v-model="computedStartDateFormatted"
                      label="Từ ngày"
                      hint="DD-MM-YYYY"
                      persistent-hint
                      prepend-icon="fa-calendar-alt"
                      readonly
                      v-on="on"
                      ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
              </v-menu>
            </v-layout>
          </v-flex>
          <v-flex lg4 pr-6>
            <v-layout row wrap justify-end>
              <v-menu
                  v-model="menuEnd"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                      <v-text-field
                      v-model="computedEndDateFormatted"
                      label="Đến ngày"
                      hint="DD-MM-YYYY"
                      persistent-hint
                      prepend-icon="fa-calendar-alt"
                      readonly
                      v-on="on"
                      ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
              </v-menu>
            </v-layout>
          </v-flex>
          <v-flex lg4 pr-6>
              <v-btn @click="filter_data" color="#3480c1" outlined>Xem</v-btn>
          </v-flex>
          <v-flex lg12 v-if="items">
            <v-data-table :headers="headers" :items="items" :server-items-length="items.length" :loading="loading">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.FeeShipType | display_value(feeship_type_list)}}</td>
                        <td>{{ storeDisplay(item.ReceivePlaceID) }}</td>
                        <td class="text-end">{{ item.TotalOrder | currency}}</td>
                        <td class="text-end">{{ item.TotalWeight | currency('', 1)}}</td>
                        <td class="text-end">{{ item.TotalFeeWeight | currency}}</td>
                    </tr>
                </template>
                <template v-slot:body.append v-if="summary">
                    <tr>
                        <td class="font-weight-bold" colspan="2">TỔNG</td>
                        <td class="text-end font-weight-bold">{{summary.TotalOrder | currency}}</td>
                        <td class="text-end font-weight-bold">{{summary.TotalWeight | currency('', 1)}}</td>
                        <td class="text-end font-weight-bold">{{summary.TotalFeeWeight | currency}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        </v-layout>
      </v-container>
    </div>
  </template>
  <script>
  import { mapState } from "vuex";
  import configs from "@/configs";
  import _ from "lodash";
  import moment from "moment"
  export default {
      data() {
          return {
                viewName: "thong-ke-nhap-kho",
                feeship_type_list: configs.FEESHIP_TYPE_LIST,
                dateRange: {
                    startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                    endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
                },
                menuStart: false,
                menuEnd: false,
                headers: [
                    {
                        text: "Hình thức",
                        value: "FeeShipType",
                        values: configs.FEESHIP_TYPE_LIST,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Kho VN",
                        value: "ReceivePlaceID",
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Số đơn",
                        value: "TotalOrder",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng cân/khối",
                        value: "TotalWeight",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng cước",
                        value: "TotalFeeWeight",
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    }
                ]
          };
      },
      computed: {
        ...mapState({
            items: state => state.analytic.realtime_import,
            loading: state => state.analytic.loading,
            stores: (state) => state.commons.stores,
        }),
        summary() {
            var ret = {
                'TotalOrder': _.sumBy(this.items, 'TotalOrder'),
                'TotalWeight': _.sumBy(this.items, 'TotalWeight'),
                'TotalFeeWeight': _.sumBy(this.items, 'TotalFeeWeight')
            };
            return ret;
        },
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        }
      },
      methods: {
            filter_data: function () {
                var param = {
                    startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                    endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
                };
                this.$store.dispatch("analytic/getRealtimeVNImport", param);
            },
            storeDisplay(value) {
                const store = _.find(this.stores, { ID: value });
                return store ? store.Name : "";
            },
      },
      mounted() {
          this.$store.dispatch("commons/getAllStores");
          this.filter_data();
          this.$root.$emit('REQUEST_ROOT_OPTION', {});
          this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
      },
      beforeDestroy() {
          this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
      }
  };
  </script>